import React from 'react';
import { observer } from 'mobx-react';
import { TeamMemberStore } from '@seedlang/stores';
import { Link } from 'react-router';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import InPlaceImageUpload from 'components/form/in_place_image_upload';
import autobind from 'autobind-decorator';
import Spinner from 'components/spinner';
import { computed } from 'mobx';
import Grid from 'components/layout/grid';

@observer
class TeamMemberEdit extends React.Component {

  componentDidMount() {
    this.getTeamMember();
  }

  @autobind getTeamMember() {
    TeamMemberStore.getShow({
      ids: {
        teamMemberId: this.props.params.teamMemberId,
      },
    });
  }

  @computed get teamMember() {
    return TeamMemberStore.showData;
  }

  render() {
    if (TeamMemberStore.hasOutstandingRequests) {
      return <Spinner />;
    }

    return (
      <div className='team-member-builder-edit'>
        <div style={{ marginBottom: 20 }}>
          <Link to={{ name: 'builder.team_members.index' }}>
            ← Back to all team members
          </Link>
        </div>
        <Grid columns={2} gap='sm'>
          <fieldset>
            <legend>Profile Image</legend>
            <InPlaceImageUpload
              image={this.teamMember.image}
              model='images'
              onChange={this.getTeamMember}
              querystring={{
                imageable_id: this.teamMember.id,
                imageable_type: 'TeamMember',
              }}
            />
          </fieldset>
          <fieldset>
            <legend>Name</legend>
            <InPlaceText
              id={this.teamMember.id}
              defaultValue={this.teamMember.name}
              model='team_members'
              field='name'
            />
          </fieldset>
          <fieldset>
            <legend>Title</legend>
            <InPlaceText
              id={this.teamMember.id}
              defaultValue={this.teamMember.title}
              model='team_members'
              field='title'
            />
          </fieldset>
          <fieldset>
            <legend>Active</legend>
            <InPlaceCheckbox
              id={this.teamMember.id}
              value={this.teamMember.active}
              model='team_members'
              field='active'
            />
          </fieldset>
        </Grid>

        <InPlaceText
          legend='Bio'
          richText
          inputType='textarea'
          id={this.teamMember.id}
          defaultValue={this.teamMember.bio}
          model='team_members'
          field='bio'
        />
      </div>
    );
  }
}

export default TeamMemberEdit;